import { API_PASSWORD, API_URL, API_USER } from "@shared/config";
import { useApiStore } from "./model";

export async function customFetch(
  input: RequestInfo,
  init?: RequestInit
): Promise<Response> {
  async function signIn(): Promise<void> {
    const body = new FormData();
    body.append("username", API_USER);
    body.append("password", API_PASSWORD);
    const response = await fetch(`${API_URL}/api/signIn/`, {
      method: "POST",
      body,
    });
    const data = await response.json();
    useApiStore.setState({ authorizationToken: data.token });
  }

  const { authorizationToken } = useApiStore.getState();
  if (!authorizationToken) {
    await signIn();
    return customFetch(input, init);
  }

  const headers = new Headers(init?.headers);
  headers.append("Authorization", `Token ${authorizationToken}`);
  const response = await fetch(input, {
    cache: "default",
    ...init,
    headers,
  });

  if (response.status === 401) {
    await signIn();
    return customFetch(input, init);
  }

  return response;
}
